import {updateURLHashFromLineRange} from '@github-ui/diffs/document-hash-helpers'
import {ariaAnnounceForLineRange} from './announce-selected-line-changes'
import type {LineRange} from '@github-ui/diffs/types'

export function handleLineSelectionEffects({
  diffAnchor,
  endLineNumber,
  endOrientation,
  startLineNumber,
  startOrientation,
}: LineRange) {
  if (!startLineNumber || !endLineNumber) return

  updateURLHashFromLineRange({
    diffAnchor,
    endLineNumber,
    endOrientation,
    startLineNumber,
    startOrientation,
  })
  ariaAnnounceForLineRange({
    diffAnchor,
    endLineNumber,
    endOrientation,
    startLineNumber,
    startOrientation,
  })
}
